import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LearningPortal from "../../assets/images/learningportal.svg";
import { useRegisterMutation } from "../../features/auth/authApi";

const StudentReistration = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const [state, setState] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  // const [login, { data, isLoading, error: responseError }] = useLoginMutation();

  const [register, { data, isLoading, error: responseError }] =
    useRegisterMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(state);
    if (state.password !== state.confirmPassword) {
      setError("Password doesn't match");
      return;
    }
    const values ={
      ...state,
      role: "student",
      confirmPassword: undefined
    }
    register(values);
  };

  useEffect(() => {
    // if (responseError?.data) {
    //     setError(responseError.data);
    // }
    if (data?.accessToken && data?.user) {
      navigate("/student/course")
    }
  }, [data, responseError, navigate]);

  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img
            className="h-12 mx-auto"
            src={LearningPortal}
            alt="Learning Portal"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Create Your New Account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="name" className="sr-only">
                Name
              </label>
              <input
                id="name"
                name="name"
                type="name"
                autoComplete="name"
                required
                className="login-input rounded-t-md"
                placeholder="Student Name"
                value={state.name}
                onChange={handleChange}
                />
            </div>
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="login-input"
                placeholder="Email address"
                value={state.email}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="login-input"
                placeholder="Password"
                value={state.password}
                onChange={handleChange}
              />
            </div>
            <div>
              <label htmlFor="confirm-password" className="sr-only">
                Confirm Password
              </label>
              <input
                id="confirm-password"
                name="confirmPassword"
                type="password"
                autoComplete="confirm-password"
                required
                className="login-input rounded-b-md"
                placeholder="Confirm Password"
                value={state.confirmPassword}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="flex items-center justify-end">
            <div className="text-sm">
              Already have an account? &nbsp;
              <Link
                to="/student/login"
                className="font-medium text-violet-600 hover:text-violet-500"
              >
              Login here
              </Link>
            </div>
          </div>
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              disabled={isLoading}
            >
              Create Account
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default StudentReistration;
